import LazyLoad from 'react-lazyload'
import RecommendedReadsItem from '../../../../shared/BrandPages/RecommendedReads/RecommendedReadsItem'
import CustomSlider from '../../../../shared/BrandPages/RecommendedReads/CustomSlider'
import classNames from 'classnames'
import PropTypes from 'prop-types'

export const RecommendedReadsComponent = ({ data }) =>
  data.map((items, index) => <RecommendedReadsItem {...items} key={index} />)

const RecommendedReads = ({ data }) => {
  return (
    <div className={`gap-x-primary grid grid-cols-4 py-12 lg:grid-cols-12`}>
      <div
        className={classNames('col-span-full lg:col-span-11 lg:col-start-2')}
        id="recommended-reads"
      >
        <h3 className="px-10 pb-8 text-center text-2.5xl font-bold lg:px-0 lg:pb-16 lg:text-37">
          Learn more about Freedom Debt Relief
        </h3>
        <div className="lg:mx-auto">
          <LazyLoad placeholder={<RecommendedReadsComponent data={data} />}>
            <CustomSlider data={data} />
          </LazyLoad>
        </div>
      </div>
    </div>
  )
}

RecommendedReads.propTypes = {
  data: PropTypes.array,
}
RecommendedReads.defaultProps = {
  data: [],
}

export default RecommendedReads
